import cookie from "cookie";
import {
  ATTRIBUTION_COOKIE_NAME,
  parseAttributionCookieValue,
  type UtmParams,
} from "@ecologi/shared";

const COOKIE_DOMAIN = process.env.NEXT_PUBLIC_COOKIE_CONSENT_DOMAIN;

export function getAttributionCookie(): UtmParams | null {
  if (typeof document === "undefined") return null;

  const cookies = cookie.parse(document.cookie);
  const value = cookies[ATTRIBUTION_COOKIE_NAME];

  if (!value) return null;

  return parseAttributionCookieValue(value);
}

export function clearAttributionCookie(): void {
  if (typeof document === "undefined") return;

  // Clear on root domain (for cookies set by GTM on .ecologi.com)
  if (COOKIE_DOMAIN) {
    document.cookie = cookie.serialize(ATTRIBUTION_COOKIE_NAME, "", {
      maxAge: 0,
      domain: COOKIE_DOMAIN,
      path: "/",
    });
  }

  // Clear on exact hostname (for cookies set directly by the app)
  document.cookie = cookie.serialize(ATTRIBUTION_COOKIE_NAME, "", {
    maxAge: 0,
    path: "/",
  });
}
